<template>
    <main id="main" class="ms-sm-auto">
        <div class="container">

            <div class="d-flex">
                <div class="home-page flex">
                    <div class="title">{{$t('p_empty_children_title')}}</div>
                    <div class="desc">{{$t('p_empty_children_text')}}
                    </div>
                    <div><b>{{$t('p_empty_children_text1')}}</b></div>
                    <div>
                        <router-link :to="{ name: 'parent_connect' }"  class="btn btn-connect-account" style="margin: 35px 0 235px 0;">{{ $t('p_mapping_title') }}</router-link>
                    </div>
                </div>
                <div>
                    <img src="/themes/web/assets/images/fish.svg" alt="">
                </div>
            </div>

        </div>
    </main>

</template>

<script>
    import axios from "axios";
    import {pushQueries, soundClick, toPercent} from '../../utils/utils'
    import {mapGetters} from 'vuex'
    import {getParentReport} from "../../models/parent";

    export default {
        name: "ParentConnectHome",
        title: 'Parents - Connect',

        data() {
            return {
            };
        },

        created() {
            this.$store.commit('setMenuActive', 'parent');

            this.fetch();
        },

        methods: {
            fetch(){}
        }
    }
</script>

<style scoped>

</style>
